<template>
    <el-container>
        <comHeader style="height: 80px"></comHeader>
        <!-- 不知道怎么回事地图右侧一侧一直有小条空白 -->
        <!-- 暂时的办法是 comHome 宽度设置102% 这里父亲容器加  overflow-x: hidden;-->
        <el-main style="width: 100%; overflow-x: hidden">
            <router-view></router-view>
        </el-main>
        <!-- 页面底部 -->
        <el-footer>
            <comFooter></comFooter>
        </el-footer>
    </el-container>
</template>

<script>
import comHeader from '@/V3/Header/comHeader'
import comFooter from '@/V3/Footer/comFooter'
export default {
    name: 'Index',
    data() {
        return {}
    },
    components: {
        comHeader,
        comFooter,
    },
    mounted() {},

    methods: {
    },
}
</script>

<style src='./css/v3commpage.css' ></style>





// WEBPACK FOOTER //
// src/V3/Index.vue